"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContentItem = /** @class */ (function () {
    /**
    * Base class representing content item type. All content type models need to extend this class.
    * @constructor
    */
    function ContentItem(data) {
        if (data) {
            Object.assign(this, data);
        }
    }
    return ContentItem;
}());
exports.ContentItem = ContentItem;
//# sourceMappingURL=content-item.class.js.map